import * as Services from "../../../Service/Service"
import * as Url from '../../../Service/Url';

export const GetUserDetail = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_USER_DETAIL + payload.UD_emp_email, token)
  return res;
};

export const updateUserDetailhide = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_USER_DETAILS_HIDE + `UD_id=${payload.UD_id}&UD_is_hide_welcome_msg=${payload.UD_is_hide_welcome_msg}`, payload, token)
  return res;

};
